<!--
 * @Desc: 意见反馈
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-08 11:02:17
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-index">
        <!-- 菜单 -->
        <menuCommon :active="$route.query.active"></menuCommon>
        <!-- 内容区 -->
        <section class="page-contact">
            <div class="container">
                <el-form
                    ref="ruleForm"
                    :model="viewData"
                    :rules="rules"
                    label-width="100px"
                >
                    <el-row :gutter="32">
                        <el-col :span="10">
                            <el-form-item label="内容" prop="content">
                                <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入内容"
                                    v-model="viewData.content"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="32">
                        <el-col :span="10">
                            <el-form-item label="联系方式" prop="contact_way">
                                <el-input
                                    placeholder="请输入联系方式"
                                    v-model="viewData.contact_way"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div style="padding-left: 240px; margin-top: 40px">
                        <el-button
                            type="primary"
                            @click="submitForm('ruleForm')"
                            >提交</el-button
                        >
                    </div>
                </el-form>
            </div>
        </section>
        <!-- 页脚 -->
        <footerCommon></footerCommon>
        <!-- 返回顶部 -->
        <!-- <div class="nav-hold">
            <div class="nav-top"><img class="thu" src="../../public/statics/images/arr.png"></div>
        </div> -->
    </div>
</template>

<script>
import menuCommon from "./../components/Common/Menu.vue";
import BreadCrumb from "./../components/Common/BreadCrumb.vue";
import footerCommon from "./../components/Common/Footer.vue";
export default {
    name: "home",
    data() {
        return {
            // 栏目详情
            cateData:'',
            // 面包屑展示数据
            objectData: {
                title: "",
                navArray: [
                ],
            },
            viewData: {
                content: "",
                contact_way: "",
            },
            rules: {
                content: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                contact_way: [
                    {
                        required: true,
                        message: "请输入联系方式",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {
        menuCommon,
        footerCommon,
        BreadCrumb,
    },
    created() {
        // this.Cookies.set('theme', 909, { expires: 365 })
        // console.log(this.Cookies.get('theme'))
    },
    mounted() {
        // this.cateDetail()
    },
    beforeDestroy() {},
    methods: {
        // 栏目详情 面包屑展示
        cateDetail(){
            let that = this
            that.$api.index.cateDetail({id:this.$route.query.active}).then((res) => {
                if (res.code == 200) {
                    that.cateData = res.result
                    that.objectData.title = that.cateData.name
                    that.objectData.navArray = that.cateData.breadcrumb
                }
            })
        },
        // 提交意见反馈
        submitForm(formName) {
            let that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    that.$api.index.feedback(that.viewData).then((res) => {
                        if (res.code == 200) {
                            that.$message.success(res.msg);
                            that.$refs["ruleForm"].resetFields();
                            that.viewData = {
                                content: "",
                                contact_way: "",
                            };
                        }
                    });
                } else {
                    that.$message.warning("请认真填写数据");
                    return false;
                }
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
.page-contact {
    box-sizing: border-box;
    min-height: 60vh;
    padding: 100px 0;
}
.page-contact .container {
    overflow: hidden;
    padding-left: 100px;
}
</style>